<template>
  <article class="article">
    <header class="article__header">
      <div class="article__header-container">
        <h1 class="article__headline">
          {{ article.title }}
        </h1>
      </div>
      <div class="article__spins">
        <label
          v-if="article.genre"
          class="article__genre">{{ article.genre }}
        </label>
        <label>SPINS</label>
        <i class="bandwagon-logo bandwagon-logo--arc" />
        <label class="article__spins-number">
          {{ article.spins }}
        </label>
      </div>
    </header>

    <section class="article__cover-image-container">
      <img
        :src="article.coverImage"
        class="article__cover-image"
        :alt="article.title"
      >
    </section>

    <section
      class="article__body"
      onmousedown="return false;"
      onselectstart="return false;"
      oncontextmenu="return false;"
    >
      <aside class="article__meta-container">
        <div class="article__meta">
          <div class="article__byline" v-if="!article.hasBrandedContentCategory">
            Words by {{ article.author }}
          </div>
          <div class="article__date">
            {{ formattedPublishedAt }}
          </div>

          <ul
            v-if="article.categories.length > 0"
            class="article__category-list"
          >
            <li
              v-for="category in article.categories"
              :key="category.id"
              class="article__category-list-item"
            >
              {{ category.name }}
            </li>
          </ul>

          <div class="language-ctn" v-if="article.languageVersions.length > 0 ">
            <h4>Read in:</h4>
            <a
              v-for="version in article.languageVersions"
              :key="version.id"
              :href="`/articles/${article.slug}/${version.language}`"
              v-html="version.language"
              class="language-btn"
            />
          </div>

          <div
            v-if="article.audioActive && article.audioUrl"
          >
            <h4 class="audio-heading">Listen here:</h4>
            <div class="audio-player-container">
              <div class="audio-player-wrap">
                <button class="play-btn"><i class="fa fa-play"></i></button>
                <input
                  type="range"
                  class="seek-slider"
                  max="100"
                  value="0"
                >
                <span class="total-time">
                  <div
                    class="spinner-border"
                    role="status"
                  >
                    <span class="sr-only" />
                  </div>
                </span>
                <div class="volume-ctn">
                  <button class="mute-btn"><i class="fa fa-volume-up"></i></button>
                  <input
                    type="range"
                    class="volume-slider"
                    max="100"
                    value="100"
                  >
                </div>
                <audio
                  controls="controls"
                  controlsList="nodownload"
                  preload="metadata"
                  style="display: none"
                  class="audio-src"
                >
                  <source
                    :src="article.audioUrl"
                    type="audio/mpeg"
                  >
                </audio>
              </div>
              <div class="audio-control-mobile">
                <button class="rewind-btn">
                  <img src="/assets/rewind.svg" >
                </button>
                <button class="play-btn-mobile"><i class="fa fa-play"></i></button>
                <button class="forward-btn">
                  <img src="/assets/forward.svg" >
                </button>
              </div>
            </div>
          </div>
          <div class="article__sidebar-ad">
            <a :href="sidebarAd.url" :title="sidebarAd.message" target="_blank" v-if="sidebarAd">
              <img :src="sidebarAd.imageUrl" :alt="sidebarAd.message"/>
            </a>
            <GoogleAdvertComponent v-else />
          </div>
        </div>
      </aside>

      <aside class="article__right-ad-container">
        <div class="article__right-ad">
        </div>
      </aside>
      <section class="article__content" :id="'zoom-images-' + article.id">
        <div v-html="article.content"></div>
        <ReactionButton
          :key="article.id"
          :article="article"
        />
      </section>
      <div class="container">
        <hr class="firework-separate">
      </div>
    </section>

    <div class="newsletter__form--large">
      <NewsletterForm
        :country-newsletter-id="countryNewsletterId"
        :locale="locale"
      />
    </div>

    <div
      class="article-firework-embedded container"
    >
      <div class="article-firework-embedded-wrapper">
        <h2>Stories</h2>
        <fw-embed-feed
          channel="bandwagon"
          playlist="o88O1o"
          mode="grid"
          open_in="default"
          max_videos="8"
          paginate_by="4"
          placement="middle"
          player_placement="bottom-right"
          title=""
          branding="false"
        ></fw-embed-feed>
      </div>
    </div>
  </article>
</template>

<script>
import GoogleAdvertComponent from "../advert/GoogleAdvertComponent.vue";
import NewsletterForm from "../shared/NewsletterForm.vue";
import ReactionButton from "../shared/ReactionButton.vue"
import Viewer from 'viewerjs';

export default {
  components: {
    GoogleAdvertComponent,
    NewsletterForm,
    ReactionButton,
  },
  props: {
    article: {
      default: () => {},
      type: Object,
    },
    sidebarAd: {
      default: () => {},
      type: Object,
    },
    countryNewsletterId: {
      type: String,
      default: 'c04c8e2b7e',
    },
    locale: {
      type: String,
      default: 'en',
    },
  },
  computed: {
    formattedPublishedAt() {
      if (this.article.publishedAt === undefined) return "";

      return new Date(this.article.publishedAt).toLocaleString("en-SG", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setupZoomOnImages();
    });
  },
  methods: {
    setupZoomOnImages() {
      const articleId = 'zoom-images-' + this.article.id;
      new Viewer(document.getElementById(articleId), {
        toolbar: {
          zoomIn: 2,
          zoomOut: 2,
          oneToOne: 2,
          reset: 2,
          prev: 0,
          play: 0,
          next: 0,
          rotateLeft: 2,
          rotateRight: 2,
          flipHorizontal: 2,
          flipVertical: 2,
        },
      });
    },
  }
};
</script>
